import { render, staticRenderFns } from "./faturamentoComponent.vue?vue&type=template&id=23da9707&scoped=true&"
import script from "./faturamentoComponent.vue?vue&type=script&lang=js&"
export * from "./faturamentoComponent.vue?vue&type=script&lang=js&"
import style0 from "./faturamentoComponent.vue?vue&type=style&index=0&id=23da9707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da9707",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VCol,VDataTable,VIcon,VRow,VSelect})
